
const { Map } = require('immutable');

const applicationStatusCodeSelector = (state) => {
	const error = state.getIn(['resources', state.get('selectedResource'), 'error'], Map());
	return error.isEmpty()?'200':error.get('status','500');
};

module.exports = applicationStatusCodeSelector;



/** WEBPACK FOOTER **
 ** ./app/selectors/applicationStatusCodeSelector.js
 **/